module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE3LjEuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDEwMCAxMDAiPgogIDxjaXJjbGUgY3g9Ijc4IiBjeT0iNDIiIHI9IjM5IiBmaWxsPSIjYzExIi8+CiAgPHBhdGggZD0iTTg1LDE5aC04djloNmgtNnYxMU04NSw0OGgtOHY5aDZoLTZ2MTEiIHN0cm9rZS13aWR0aD0iNCIgc3Ryb2tlPSIjRkZGIiBmaWxsPSJub25lIi8+CiAgPHBhdGggZD0iTTMsMTZoNjV2MTBoLTQwdjEwaDM4djEwaC0zOHYxMWg0MHYxMWgtNjV6IiBmaWxsPSIjMDAwIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg-files/eff-logo.svg
// module id = 268
// module chunks = 1